import React from "react";
import PartnerConsent from "./PartnerConsent";
import { useAuth } from "hooks/authHooks";

interface ConsentProps {}

const ConsentPopup: React.FC<ConsentProps> = () => {
  const { isConsentFormVisible, setIsConsentFormVisible } = useAuth();

  return (
    <>
      {isConsentFormVisible && (
        <PartnerConsent setIsConsentFormVisible={setIsConsentFormVisible} />
      )}
    </>
  );
};

export default ConsentPopup;
